const isProduction = process.env.NODE_ENV === "production";
const config = {
  basename: "",
  defaultPath: "/",
  fontFamily: `'Nunito'`,
  borderRadius: 12,
  apiBaseURL: isProduction
    ? `https://ct-be.wendtindia.in/api`
    : `http://127.0.0.1:8000/api`,
};
export default config;
